import React, { Component } from 'react'
import { withStyles } from '@material-ui/core';
import { Switch, Route } from 'react-router-dom'
import Payments from './View/Payments';


const styles = theme => ({

})

class PaymentLanding extends Component {
    render() {
        return (
            <div>

                <Switch>
                    <Route exact path="/payments" render={(props) =>
                        <Payments
                            {...props}
                            history={this.props.history}
                            username={this.props.username}
                            apikey={this.props.apikey} />
                    } />

                </Switch>
            </div>
        )
    }
}

export default withStyles(styles)(PaymentLanding)